<script lang="ts" setup>
import { ref } from 'vue';
import PageMenu from './PageMenu.vue';
import { getRegistrationUrl } from '../utils/registration';

const hamburgerActive = ref(false);
</script>

<template>
  <!-- <div class="topbar-area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="d-none d-lg-block col-lg-7">
          <ul class="topbar-contact-wrap">
            <li> <a href="#"> <i class="bi bi-geo-alt"></i> 1356 Broadway, New York</a></li>
            <li> <a href="tel:6719251352587"><i class="bi bi-telephone-plus"></i> (671) 925-1352587</a></li>
            <li> <a href="mailto:info@example.com"> <i class="bi bi-envelope-open"></i> info@example.com</a></li>
          </ul>
        </div>
        <div class="col-lg-5">
          <ul class="justify-content-center topbar-social-links justify-content-lg-end">
            <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
            <li><a href="#"><i class="fab fa-instagram"></i></a></li>
            <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
            <li><a href="#"><i class="fab fa-twitter"></i></a></li>
            <li><a href="#"><i class="fab fa-whatsapp"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
  </div> -->

  <header>
    <div class="header-area header-style-two">
      <div class="container">
        <div class="row">
          <!-- eslint-disable-next-line unocss/order -->
          <div class="col-lg-12 align-items-center d-xl-flex col-xl-2 col-md-12 col-sm-12 col-xs-12">
            <!-- eslint-disable-next-line unocss/order -->
            <div class="align-items-center d-flex logo justify-content-between">
              <RouterLink to="/"><img src="../assets/images/logo.png" alt="logo" class="h-56 w-171 object-contain"></RouterLink>

              <div class="d-flex mobile-menu">

                <a href="javascript:;" class="d-block d-xl-none hamburger" :class="{ 'h-active': hamburgerActive }" @click="hamburgerActive = !hamburgerActive">
                  <span class="h-top"></span>
                  <span class="h-middle"></span>
                  <span class="h-bottom"></span>
                </a>

              </div>
            </div>
          </div>

          <PageMenu v-model:hamburger="hamburgerActive" />

          <div class="d-none d-xl-block col-2 col-xl-3">
            <div class="d-flex align-items-center nav-right justify-content-end h-100">
              <ul class="d-flex align-items-center nav-right-list">
                <li class="nav-btn">
                  <a class="primary-btn-fill" :href="getRegistrationUrl()" target="_blank">报名</a>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
</style>
